// extracted by mini-css-extract-plugin
export default {"container":"TeaDescription_container__wQmnu","textList":"TeaDescription_textList__R7ZgB","itemText":"TeaDescription_itemText__d5lEQ","aboutImage":"TeaDescription_aboutImage__ePJCL"};